export default __webpack_public_path__ + "static/media/techmonster.b0c2c977.png";